var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineVector2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 450,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 450.241l175.519-236.126c7.965-10.715 23.991-10.767 32.025-.103l70.446 93.505c7.898 10.484 23.584 10.646 31.697.327L552.927 1",
    stroke: "#EEE",
    strokeWidth: 3
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDU1IiBoZWlnaHQ9IjQ1MCIgdmlld0JveD0iMCAwIDQ1NSA0NTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yIDQ1MC4yNDFMMTc3LjUxOSAyMTQuMTE1QzE4NS40ODQgMjAzLjQgMjAxLjUxIDIwMy4zNDggMjA5LjU0NCAyMTQuMDEyTDI3OS45OSAzMDcuNTE3QzI4Ny44ODggMzE4LjAwMSAzMDMuNTc0IDMxOC4xNjMgMzExLjY4NyAzMDcuODQ0TDU1Mi45MjcgMSIgc3Ryb2tlPSIjRUVFRUVFIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+Cg==";
export { SvgLineVector2 as ReactComponent };